/* eslint-disable no-plusplus, jsx-a11y/anchor-has-content, array-callback-return, no-restricted-syntax, react/no-did-mount-set-state */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import canUseDOM from 'exenv';
import axios from 'axios';

export default class RecircByTag extends Component {
  constructor(props) {
    super(props);

    this.determineIfMobile = this.determineIfMobile.bind(this);

    this.module = React.createRef();

    this.state = {
      articles: [],
      isMobile: true,
      moduleHeadline: 'More Like This',
      moduleHeadlineURL: '/'
    };
  }

  componentDidMount() {
    if (canUseDOM) {
      const mql = window.matchMedia('(max-width: 1023px)');
      mql.addListener(this.determineIfMobile);

      this.setState(
        {
          isMobile: window.innerWidth < 1024
        },
        () => {
          const ro = new ResizeObserver(entries => {
            for (const entry of entries) {
              const cr = entry.contentRect;

              this.module.current.closest('.social').style.marginBottom = this
                .state.isMobile
                ? '1.5625rem'
                : `${cr.height + 6 + 41}px`;
            }
          });

          if (canUseDOM && this.module && this.module.current) {
            ro.observe(this.module.current);
          }
        }
      );
    }

    const articles = [];

    axios(
      `//fc-api.fastcompany.com/api/v2/posts-category-slug/fastcompany/${
        this.props.post.categories[0].slug
      }`
    ).then(res => {
      let count = 0;
      let i = 0;

      while (count < 3) {
        if (res.data.posts[i].id !== this.props.post.id) {
          articles.push(res.data.posts[i]);
          count++;
        }

        i++;
      }

      if (articles.length > 0) {
        this.setState({
          articles,
          moduleHeadlineURL: `/${this.props.post.categories[0].slug}`
        });
      }
    });
  }

  determineIfMobile(e) {
    this.setState({
      isMobile: e.matches
    });
  }

  render() {
    if (this.state.isMobile) {
      return <aside className="article-recirc-by-tag" ref={this.module} />;
    }

    return (
      <aside className="article-recirc-by-tag" ref={this.module}>
        <div className="header">
          <div className="arrow">
            <img
              src="https://images.fastcompany.net/image/upload/v1595605760/fcweb/Path_33_zlkv0h.svg"
              alt=""
            />
          </div>

          <div className="package-name">{this.state.moduleHeadline}</div>

          <a
            href={`${
              this.state.moduleHeadlineURL
            }?icid=dan902:754:0:editRecirc`}
          />
        </div>

        <div className="articles">
          {this.state.articles &&
            this.state.articles.map((article, idx) => (
              <div className="article" key={`article-${idx}`}>
                <a href={`${article.link}?icid=dan902:754:0:editRecirc`}>
                  {article.title}
                </a>
              </div>
            ))}
        </div>
      </aside>
    );
  }
}

RecircByTag.defaultProps = {
  post: {}
};

RecircByTag.propTypes = {
  post: PropTypes.shape({
    categories: PropTypes.shape([]),
    id: PropTypes.string
  })
};
